var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconShortArrowRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.4548 10.335C4.3598 10.335 4.2648 10.3 4.1898 10.225C4.0448 10.08 4.0448 9.84001 4.1898 9.69501L7.4498 6.43501C7.6898 6.19501 7.6898 5.80501 7.4498 5.56501L4.1898 2.30501C4.0448 2.16001 4.0448 1.92001 4.1898 1.77501C4.3348 1.63001 4.5748 1.63001 4.7198 1.77501L7.9798 5.03501C8.2348 5.29001 8.3798 5.63501 8.3798 6.00001C8.3798 6.36501 8.2398 6.71001 7.9798 6.96501L4.7198 10.225C4.6448 10.295 4.5498 10.335 4.4548 10.335Z",
    fill: "#288DC6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShortArrowRight);
export default __webpack_public_path__ + "static/media/icon-short-arrow-right.f9de52054ee9b5b6844f220b53b42b92.svg";
export { ForwardRef as ReactComponent };